import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import EventyService from "./EventyService";
import EventyTable from "./components/EventyTable";


export default class EventyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventy: [],

        };

    }

    componentDidMount() {
        this.pobierzListeEventow();
    }

    pobierzListeEventow(){
        EventyService.pobierzWszytskieEventy().then(function (response) {
            this.setState({eventy:response.data})
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'OcenyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-klientami',
                                    text: 'Zarządzanie klientami'
                                }, {addressUrl: '/zarzadzanie-klientami/eventy', text: 'Eventy'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                           <EventyTable data={this.state.eventy}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eventy/EventyContainer.js